import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { WSPScorecardService } from '../../../Component/Api/WSPScorecard/WSPScorecardService';
import AppTextInput from '../../../Component/Common/Components/FormValidationInputs/AppTextInput';
import { OrganisationDetails } from '../../../Component/Model/Dto/WSP/SETAScorecard';
import { WSPScorecardAtom } from '../../../State/WSPScorecard.Atom';
import { OrganisationDetailsValidationSchema } from './OrganisationDetailsValidationSchema';
import AppSelectListWithInfo, { IDropDownOptionsWithDescription } from '../../../Component/Common/Components/FormValidationInputs/AppSelectListWithInfo';
import { getIOptionsArrayWithInfo } from '../../../Helpers/DropdownWithDescriptionHelper';

export const OganisationDetailsPage = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const WSPScorecard = useRecoilValue(WSPScorecardAtom)
    const [organisationName, setOrganisationName] = useState<string>("");
    const [sicCodes, setSICCodes] = useState<IDropDownOptionsWithDescription[]>([]);

    const { reset, handleSubmit, control} = useForm({
        mode: 'all',
        resolver: yupResolver(OrganisationDetailsValidationSchema)
    });

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let scorecard = await WSPScorecardService.getScorecard(WSPScorecard.wspScorecardId);
            if (scorecard.data.id !== undefined) {
                let sicCodesResult = await WSPScorecardService.getSicCodes(scorecard.data.scorecardTypeId);
                setOrganisationName(scorecard.data.organisationName);               

                const sicodeOptions = getIOptionsArrayWithInfo(
                    sicCodesResult.data,
                    "sicCode",
                    "sicCode",
                    "description"
                );

                setSICCodes(sicodeOptions);
                if(sicCodesResult.data){
                    reset({
                        sicCode: +scorecard.data.organisationDetails.sicCode,
                        sdlNumber: scorecard.data.organisationDetails.sdlNumber
                      })
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const saveData = async (data: FieldValues) => {
        try {
            const organisationRequest: OrganisationDetails = {
                scorecardId: WSPScorecard.wspScorecardId,
                sdlNumber: data.sdlNumber,
                sicCode: data.sicCode ? data.sicCode.toString() : null
            }
            await WSPScorecardService.updateOrganisationDetails(organisationRequest);
            toast.success("Organisation Details successfully updated");
        } catch (error) {
            console.error(error);
            toast.error("Could not save Organisation Details");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <Typography variant="h4" style={{ paddingBottom: "20px" }}>
                Organisation Details
            </Typography>
            <Typography variant="body2" style={{ paddingBottom: "20px" }}>
                Capture general details for {organisationName} so we can help you with your submission.
            </Typography>
            <Box>
                <form id='addOrganisationDetailsForm' onSubmit={handleSubmit(saveData)}>
                    <Grid container mb={2} mt={2} spacing={2}>
                        <Grid item xs={12} sm={12} md={6}>
                            <AppTextInput label='SDL No. *' name='sdlNumber' control={control} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <AppSelectListWithInfo
                                control={control}
                                name="sicCode"
                                label="SIC Code"
                                items={sicCodes}
                                disabled={sicCodes.length === 0}
                                size="small"                               
                            />
                        </Grid>
                    </Grid>
                    <Grid container mb={2} spacing={2}>
                        <Grid item xs={12} sm={12} md={6}>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <LoadingButton style={{ float: 'right' }} loading={isLoading} variant='contained' form='addOrganisationDetailsForm' type="submit" color='primary'>
                                Save
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </form>
            </Box>


        </>
    )
}
